import { map, type Observable } from 'rxjs';
import { isString, replace } from 'lodash-es';
import type { FrequencyWeighting } from '@/graphql/types';
import type { DataSet } from '../../dataset';

const frequencyWeightingPrefix = 'frequencyWeighting';

const defaultUnit = 'dB';

export function getUnitWithFrequencyWeighting(config?: {
    frequencyWeighting?: FrequencyWeighting | null;
}): string {
    const frequencyWeighting = config?.frequencyWeighting;

    if (isString(frequencyWeighting) && frequencyWeighting.includes(frequencyWeightingPrefix)) {
        const weighting = replace(frequencyWeighting, frequencyWeightingPrefix, '');
        return `${defaultUnit}(${weighting})`;
    }

    return defaultUnit;
}

export function getSoundUnit$(dataSet: DataSet): Observable<string> {
    return dataSet.config$.pipe(
        map((config) =>
            config && 'frequencyWeighting' in config
                ? getUnitWithFrequencyWeighting(config)
                : defaultUnit
        )
    );
}
